import script from "./imagePreviewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./imagePreviewer.vue?vue&type=script&setup=true&lang=ts"

import "./imagePreviewer.vue?vue&type=style&index=0&id=09cbf3ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09cbf3ec"]])

export default __exports__